import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/Register/Register';
import Login from './pages/Login/Login';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import User from './pages/User/User';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import TokensPage from './pages/Tokens/Tokens';
import AccountsPage from './pages/Accounts/Accounts';
import ChatPage from './chat/components/ChatPage';
import Logout from './pages/Logout';
import VerificationBanner from './components/VerificationBanner/VerificationBanner';
import * as Sentry from "@sentry/react";
import config from "./Config";
import './App.css';
import './chat/styles/chat.css';
import { isLoggedIn } from "./utils/utils";
import BillingPage from './pages/Billing/Billing';
import PaymentSuccessPage from './pages/Billing/PaymentSuccess';
import SubscriptionSuccessPage from './pages/Billing/SubscriptionSuccess';

function App() {
    // Set up Sentry
    if (config.sentryDSN) {
        Sentry.init({
            dsn: config.sentryDSN,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0.0,
            replaysOnErrorSampleRate: 1.0,
        });
    }

    return (
        <div className="App">
            <BrowserRouter>
                {/* Show verification banner for logged-in users if needed */}
                {isLoggedIn() && <VerificationBanner />}

                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/login" element={isLoggedIn() ? <Navigate to="/" /> : <Login />} />
                    <Route path="/register" element={isLoggedIn() ? <Navigate to="/" /> : <Register />} />
                    <Route path="/forgot-password" element={isLoggedIn() ? <Navigate to="/" /> : <ForgotPassword />} />
                    <Route path="/reset-password" element={isLoggedIn() ? <Navigate to="/" /> : <ResetPassword />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/logout" element={<Logout/>}/>
                    <Route path="/user" element={<User/>}/>
                    <Route path="/tokens" element={<TokensPage/>}/>
                    <Route path="/accounts" element={<AccountsPage/>}/>
                    <Route path="/chat" element={<ChatPage/>}/>
                    <Route path="/billing" element={<BillingPage/>}/>
                    <Route path="/payment/success" element={<PaymentSuccessPage/>}/>
                    <Route path="/billing/subscription-success" element={<SubscriptionSuccessPage/>}/>
                    <Route path="/payment/cancel" element={<Navigate to="/billing" />}/>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;